import * as React from "react";
const SvgFiRrScalpelPath = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-scalpel-path_svg__a)">
      <path
        fill="#062147"
        d="M23.124.873C21.99-.26 20.014-.26 18.88.873L.295 19.459a1 1 0 0 0-.281.554c-.058.37.014.923.387 1.357.244.285.706.624 1.524.624.474 0 .879.009 1.116 0 1.8-.071 3.552-.48 5.208-1.211 2.59-1.146 4.37-3.202 5.16-5.955l9.713-9.712a3 3 0 0 0 0-4.242zM7.44 18.953c-1.425.63-2.932.98-4.48 1.042a6 6 0 0 1-.38.006l7.034-7.033 1.769 1.65c-.668 2.016-1.994 3.473-3.943 4.335M21.709 3.7l-9.216 9.216-1.463-1.364 9.266-9.266a1.02 1.02 0 0 1 1.414 0 1 1 0 0 1-.001 1.414M17.999 23a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m-6 0a1 1 0 0 1-1 1H9a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m12 0a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-scalpel-path_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrScalpelPath;
